export default {
  methods: {
    addNotification (notification) {
      this.$store.dispatch('addNotification', notification)
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userIsAdmin () {
      return this.$store.getters.user && this.$store.getters.user.role === 'Admin'
    },
    currentUser () {
      return this.$store.getters.user
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/shared/index.js